// Identity access for the signaling core. The guest caller is anonymous (everything
// resolves to null/empty); the staff softphone (roadmap #41) will populate these.
// Replaces the old Redux AuthReducer reads and login.service.getLoggedInUser.
import { globals } from './globals'

export const getAuthToken = (): string => globals.authToken || ''

export const getAuthEmail = (): string | null => globals.email || null

export const getAuthUser = (): any => globals.userData || null

export const getLoggedInUser = async (): Promise<any> => globals.userData || null
